import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { CanalVendaLogoBadgeModule } from '../logo-badge';

import { CanalVendaInputGroupComponent } from './canal-venda-input-group.component';

@NgModule({
    imports: [
        SharedModule,
        CanalVendaLogoBadgeModule
    ],
    declarations: [
        CanalVendaInputGroupComponent
    ],
    exports: [
        CanalVendaInputGroupComponent
    ]
})
export class CanalVendaInputGroupModule { }
